import type { Platform, ProductType } from '@mwl/core-lib';

import type { WithWebkit } from './CasinoGamePage.types';

export interface LoadRecommendedGamesParams {
  platform: Platform;
  currency: string;
  productType: ProductType;
}

export const isFullscreenSupports = () =>
  Boolean(
    document.documentElement.requestFullscreen ||
      (document.documentElement as WithWebkit<HTMLElement>).webkitRequestFullscreen ||
      (document.documentElement as WithWebkit<HTMLElement>).mozRequestFullScreen ||
      (document.documentElement as WithWebkit<HTMLElement>).msRequestFullscreen,
  );
